import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/database';
import _ from 'lodash'
import format from 'date-fns/format'
import addDays from 'date-fns/add_days';
import subDays from 'date-fns/sub_days';
import differenceInDays  from 'date-fns/difference_in_calendar_days'
import {globalfunc} from '../globalfunc.js';

export default {
    namespaced: true,
    state: {
        openFeedbackLoading:false,
        recognitionDrivenLoading:false,
        activeManagersLoading:false,
        strongCompanyCultureLoading:false,
        highWellBeingLoading:false,
        openFeedback:{
            status: true,
            percentage: 0,
            required: 0,
          },
        recognitionDriven: {
            status: true,
            percentage: 0,
            required: 0,
          },
        activeManagers: {
            status: true,
            percentage: 0,
            required: 0,
          },
          strongCompanyCulture: {
            status: true,
            percentage: 0,
            value: 0,
            required: 0,
          },
          highWellBeing: {
            status: true,
            percentage: 0,
            value: 0,
            required: 0,
          },
          happiestWorkplace: {
            status: false,
            percentage: 0,
            value: 0,
            required: 0,
          },
        openFeedbackTimeline:{
            timeLine: [],
            consistency: 0,
            currentStreak: 0,
            periods: 80,
            length: 0,
            width: 0,
        },
        recognitionDrivenTimeline: {
          timeLine: [],
            consistency: 0,
            currentStreak: 0,
            periods: 80,
            length: 0,
            width: 0,
        },
        activeManagersTimeline: {
          timeLine: true,
            consistency: 0,
            currentStreak: 0,
            periods: 80,
            length: 0,
            width: 0,
        },
        strongCompanyCultureTimeline: {
          timeLine: [],
            consistency: 0,
            currentStreak: 0,
            periods: 80,
            length: 0,
            width: 0,
        },
        highWellBeingTimeline: {
          timeLine: [],
            consistency: 0,
            currentStreak: 0,
            periods: 80,
            length: 0,
            width: 0,
        },
        happiestWorkplaceTimeline: {
          timeLine: [],
          consistency: 0,
          currentStreak: 0,
          periods: 5,
          length: 0,
          width: 0,
        },
        questionCultureCustom: [],
        questionMasterArr: [],

    },
    mutations: {
        setOpenFeedback(state:any, result:any) {
            state.openFeedback = result
          },
        setRecognitionDriven(state:any, result:any) {
            state.recognitionDriven = result
          },
        setActiveManagers(state:any, result:any) {
            state.activeManagers = result
          },
        setStrongCompanyCulture(state:any, result:any) {
            state.strongCompanyCulture = result
          },
        setHighWellBeing(state:any, result:any) {
            state.highWellBeing = result
          },
        setHappiestWorkplace(state:any, result:any) {
            state.happiestWorkplace = result
          },
          setOpenFeedbackTimeline(state:any, result:any) {
            state.openFeedbackTimeline = result
          },
        setRecognitionDrivenTimeline(state:any, result:any) {
            state.recognitionDrivenTimeline = result
          },
        setActiveManagersTimeline(state:any, result:any) {
            state.activeManagersTimeline = result
          },
        setStrongCompanyCultureTimeline(state:any, result:any) {
            state.strongCompanyCultureTimeline = result
          },
        setHighWellBeingTimeline(state:any, result:any) {
            state.highWellBeingTimeline = result
          },
        setOpenFeedbackLoading(state:any, result:any) {
            state.openFeedbackLoading = result
          },
          setRecognitionDrivenLoading(state:any, result:any) {
            state.recognitionDrivenLoading = result
          },
          setActiveManagersLoading(state:any, result:any) {
            state.activeManagersLoading = result
          },
          setStrongCompanyCultureLoading(state:any, result:any) {
            state.strongCompanyCultureLoading = result
          },
          setHighWellBeingLoading(state:any, result:any) {
            state.highWellBeingLoading = result
          },
          setHappiestWorkplaceTimeline(state:any, result:any) {
            state.happiestWorkplaceTimeline = result
          },
          setCultureCustom(state: any, value: any) {
            state.questionCultureCustom = value
          },
          setQuestionMasterArr(state: any, value: any) {
            state.questionMasterArr = value
          },

    },
    actions: {

      async getOpenEnded({commit,rootState,dispatch,state}:any, value:any){
        commit('setOpenFeedbackLoading',true)
        let _open_ended_Timeline:Array<any> = [];
        let answer_count=0
        let year=format(new Date(),"YYYY")
        let consistency=0
        let currentStreakOpenEnded=0
        let last30={}
        let available_count=0
        let answer_countTimeline={}
        let available_countTimeline={}
        let percentOpenEnd={}
        let currentDate=format(new Date(),"YYYY-MM-DD")
        let thisYear=format(new Date(`${value}-01-01`),"YYYY-MM-DD")//format(subDays(currentDate,30),"YYYY-MM-DD")
        let last30Day=format(subDays(currentDate,30),"YYYY-MM-DD")
        const diffInDays = differenceInDays(new Date(currentDate), new Date(thisYear));
        firebase.firestore().collection('summary_openend_day').where("company", "==", rootState.authen.user.company).get()
        .then((querySnapshot)=> {
        querySnapshot.forEach((doc)=> {
            let data=doc.data()
            var _date=format(new Date(data.date),"YYYY-MM-DD")
            
            if(_date>=last30Day&&_date<=currentDate)
            {
              available_count+=data.total
              answer_count+=data.answer
            }
            if(_date>=thisYear&&_date<=currentDate)
            {
         
              
              if(!available_countTimeline[data.date]){
                available_countTimeline[data.date]=0
               }
               available_countTimeline[data.date]+=data.total
               if(!answer_countTimeline[data.date]){
                answer_countTimeline[data.date]=0
               }
               answer_countTimeline[data.date]+=data.answer
            }
            

        })
        if(year==value){
        var open_ended=(Math.round((answer_count)*100/(available_count)))
        let openFeedback={
          status: true,
          percentage: isNaN(open_ended)?0:open_ended,
          required: 40,
        }
        commit('setOpenFeedback',openFeedback)

      }
        for(var i=0;i<=diffInDays;i++){
          let _date=format(addDays(thisYear,i),"YYYY-MM-DD")
          if(!last30[_date]){
            last30[_date]={answer:0,available:0}
            
          }
          for(var j=0;j<30;j++){
            let beforeDate=format(subDays(_date,j),"YYYY-MM-DD")
              if(answer_countTimeline[beforeDate]&&available_countTimeline[beforeDate]){
                last30[_date].answer+=answer_countTimeline[beforeDate]
                last30[_date].available+=available_countTimeline[beforeDate]
              }
              
              
            
            if(j===29){
              var open_endedTimeline=(Math.round((last30[_date].answer)*100/(last30[_date].available)))
              if(open_endedTimeline>=40){
                consistency++
                _open_ended_Timeline.push(1)
             }else {
              _open_ended_Timeline.push(0)
             }
            }
          }
          
        } 
    for(let i=_open_ended_Timeline.length;i>0;i--){
      if(_open_ended_Timeline[i-1]==1){
        currentStreakOpenEnded++
      }else {
        break
      }
      
    }

        let openFeedbackTimeline={
          consistency: Math.round(consistency*100/diffInDays),
          currentStreak: currentStreakOpenEnded,
          timeLine:_open_ended_Timeline,
          periods:40,
          length: _open_ended_Timeline.length,
          width:722 / _open_ended_Timeline.length
        }
        commit('setOpenFeedbackTimeline',openFeedbackTimeline)
        commit('setOpenFeedbackLoading',false)
      })
      },
      
      
      // async getData({commit,rootState,dispatch,state}:any, value:any){
      //   commit('setStrongCompanyCultureLoading',true)
      //   commit('setHighWellBeingLoading',true)
      //       let Culture_dataSum=0
      //       let Culture_maxmimum =0
      //       let who5_dataSum=0
      //       let who5_maxmimum =0
      //       let count_achieved=0
      //       let question=['-MjPYFeALtFMAJkTEiFn','-MjPZ15ImFhkjDiMI3gH','-MjPZVq3sRBZJwtr7_Tx','-MjP_2__thuvnVc_RY0k','-MjP_R_bWBdQvFhf5BTY',
      //       '-MdMv_XgThL0o2iunlhE','-MdMw8kfpZtxnppGUA1f','-MdMyavdF-YvuyzW6cA5','-MdMz-TodEXbj3AC68oP','-MjP_R_bWBdQvFhf5BTY']
  
      //   firebase.firestore().collection('insight_teams_report_card_fix').where('company','==',rootState.authen.user.company).where('quest_id',"in",question).get().then(snapshot => {
      //       snapshot.forEach(childSnapshot => {
      //           var _data = childSnapshot.data()
      //           console.log("insight_teams_report_card_fix",snapshot.size);
      //           if(_data.quest_id=='-MjPYFeALtFMAJkTEiFn'||
      //           _data.quest_id=='-MjPZ15ImFhkjDiMI3gH'||
      //           _data.quest_id=='-MjPZVq3sRBZJwtr7_Tx'||
      //           _data.quest_id=='-MjP_2__thuvnVc_RY0k'||
      //           _data.quest_id=='-MjP_R_bWBdQvFhf5BTY'){
      //               if(_data.answer){
      //                   for(let value in _data.answer){
      //                       Culture_dataSum += (_data.answer[value]) * (5 - parseInt(value))
      //                       Culture_maxmimum += _data.answer[value] * 5
      //                   }
      //               }
                    
      //           }else if(_data.quest_id=='-MdMv_XgThL0o2iunlhE'||
      //           _data.quest_id=='-MdMw8kfpZtxnppGUA1f'||
      //           _data.quest_id=='-MdMyavdF-YvuyzW6cA5'||
      //           _data.quest_id=='-MdMz-TodEXbj3AC68oP'||
      //           _data.quest_id=='-MdMzwfySVTjhOAGoxTP'){
      //               if(_data.answer){
      //                   for(let value in _data.answer){
      //                       who5_dataSum += (_data.answer[value]) * (5 - parseInt(value))
      //                       who5_maxmimum += _data.answer[value] * 5
      //                   }
      //               }
                    
      //           }

      //       })

      //       let cal_Culture= (Math.round((Culture_dataSum)*100/(Culture_maxmimum)))
      //       let cal_who5= (Math.round((who5_dataSum)*100/(who5_maxmimum)))
      //       //console.log("cal_activeManager",cal_activeManager)
      //       let strongCompanyCulture= {
      //           status: true,
      //           percentage: cal_Culture,
      //           value: cal_Culture,
      //           required: 80,
      //         }
      //         if(cal_Culture>=80){
      //           count_achieved++
      //        }
      //         commit('setStrongCompanyCulture',strongCompanyCulture)
      //       let who5= {
      //           status: true,
      //           percentage: cal_who5,
      //           value: cal_who5,
      //           required: 80,
      //         }
      //         if(cal_who5>=80){
      //           count_achieved++
      //        }
      //         commit('setHighWellBeing',who5)
              

      //   })


      // },

      async getCultureAndHighWellBeing({commit,rootState,dispatch,state}:any, value:any){
        commit('setStrongCompanyCultureLoading',true)
        commit('setHighWellBeingLoading',true)
          let currentDate=format(new Date(),"YYYY-MM-DD")
          let year=format(new Date(),"YYYY")
          let last30day=`${value}-01-01`//format(subDays(currentDate,30),"YYYY-MM-DD")
          let Culture_count=0
          let CultureCount=0
          let MostRecentCulture=""
          let Culture_dataSumTimeline={}
          let Culture_maxmimumTimeline ={}
          let culture:Array<any> = [];
          let who_5:Array<any> = []
          let who5_dataSumTimeline={}
          let who5_maxmimumTimeline ={}
          let who5_count=0
          let who5Count=0
          let currentStreakwho_5=0
          let currentStreakCulture=0
          var MostRecentWho5=""
          let question=['-MdMv_XgThL0o2iunlhE','-MdMw8kfpZtxnppGUA1f','-MdMyavdF-YvuyzW6cA5','-MdMz-TodEXbj3AC68oP','-MjP_R_bWBdQvFhf5BTY']
          let questionCulture = ['-MjPYFeALtFMAJkTEiFn','-MjPZ15ImFhkjDiMI3gH','-MjPZVq3sRBZJwtr7_Tx','-MjP_2__thuvnVc_RY0k','-MjP_R_bWBdQvFhf5BTY']
          let questionCultureCustom: Array<any> = state.questionCultureCustom || []
          let questionMasterArr: Array<any> = state.questionMasterArr || []
          let isUsingCultureCustom = false
          if(questionCultureCustom.length == 0 || Object.keys(questionMasterArr).length == 0){
            await firebase.database().ref('questions').orderByChild('report_card').equalTo('Y').once('value', snapshot => {
              snapshot.forEach((doc): any => {
                  const data = doc.val()
                  data.key = doc.key
                  questionMasterArr[data.key] = data
                  if(data.company == rootState.authen.user.company){
                      if(data.culture_index == true){
                          questionCultureCustom.push(data.key)
                      }
                  }
              })
            })
            if(questionCultureCustom.length > 0){
              commit('setCultureCustom', questionCultureCustom)
            }
            if(Object.keys(questionMasterArr).length > 0){
              commit('setQuestionMasterArr', questionMasterArr)
            }
          }
          if(questionCultureCustom.length > 0){
            question.push(...questionCultureCustom)
            isUsingCultureCustom = true
          }else{
            question.push(...questionCulture)
          }
          const diffInDays = differenceInDays(new Date(currentDate), new Date(last30day));
      firebase.firestore().collection('insight_teams_report_card').where('company','==',rootState.authen.user.company).where('quest_id',"in",question).get().then(snapshot => {
          snapshot.forEach(childSnapshot => {
              var _data = childSnapshot.data()
              let _date=format(_data.date,"YYYY-MM-DD")
              if(_date>=last30day&&_date<=currentDate){
                if(questionCultureCustom.includes(_data.quest_id) || questionCulture.includes(_data.quest_id)){
                  if(_data.answer){
                    
                    if(CultureCount==0){
                      MostRecentCulture=_date
                    }
                    if(_date>MostRecentCulture){
                      MostRecentCulture=_date
                    }
                    CultureCount++
                      
                      // Custom calculation (auto-detects Scale vs MC)
                      if(isUsingCultureCustom && questionCultureCustom.includes(_data.quest_id) && Object.keys(questionMasterArr).length > 0){
                        const result = globalfunc.calculateCultureScore(questionMasterArr, _data.quest_id, _data.answer);
                        if(!Culture_dataSumTimeline[_data.date]){
                          Culture_dataSumTimeline[_data.date]=0
                        }
                        Culture_dataSumTimeline[_data.date] += result.dataSum;
                        if(!Culture_maxmimumTimeline[_data.date]){
                          Culture_maxmimumTimeline[_data.date]=0
                        }
                        Culture_maxmimumTimeline[_data.date] += result.total;
                      } else {
                        // Default weighted score calculation
                        for(let value in _data.answer){
                            
                            if(!Culture_dataSumTimeline[_data.date]){
                              Culture_dataSumTimeline[_data.date]=0
                            }
                            Culture_dataSumTimeline[_data.date]+=(_data.answer[value]) * (5 - parseInt(value))
                            if(!Culture_maxmimumTimeline[_data.date]){
                              Culture_maxmimumTimeline[_data.date]=0
                            }
                            Culture_maxmimumTimeline[_data.date]+=_data.answer[value] * 5
                            
                        }
                      }
                  }
                  
              }else if(_data.quest_id=='-MdMv_XgThL0o2iunlhE'||
              _data.quest_id=='-MdMw8kfpZtxnppGUA1f'||
              _data.quest_id=='-MdMyavdF-YvuyzW6cA5'||
              _data.quest_id=='-MdMz-TodEXbj3AC68oP'||
              _data.quest_id=='-MdMzwfySVTjhOAGoxTP'){
                  if(_data.answer){

                    if(who5Count==0){
                      MostRecentWho5=_date
                    }
                    if(_date>MostRecentWho5){
                      MostRecentWho5=_date
                    }
                    who5Count++
                      for(let value in _data.answer){

                          if(!who5_dataSumTimeline[_data.date]){
                            who5_dataSumTimeline[_data.date]=0
                          }
                          who5_dataSumTimeline[_data.date]+=(_data.answer[value]) * (5 - parseInt(value))
                          if(!who5_maxmimumTimeline[_data.date]){
                            who5_maxmimumTimeline[_data.date]=0
                          }
                          who5_maxmimumTimeline[_data.date]+=_data.answer[value] * 5
                          
                      }
                  }
                  
              }

            }

          })


          for(var i=0;i<=diffInDays;i++){
            let _date=format(addDays(last30day,i),"YYYY-MM-DD")
            if(Culture_dataSumTimeline[_date]&&Culture_maxmimumTimeline[_date]){
              let cal_Culture= (Math.round((Culture_dataSumTimeline[_date])*100/(Culture_maxmimumTimeline[_date])))
              if(cal_Culture>=80){
            
                Culture_count++
                culture.push(1)
             }else {
              culture.push(0)
             }
            }else {
              culture.push(0)
            }


            if(who5_dataSumTimeline[_date]&&who5_maxmimumTimeline[_date]){
              let cal_who5= (Math.round((who5_dataSumTimeline[_date])*100/(who5_maxmimumTimeline[_date])))
              if(cal_who5>=80){
                if(!state.countTimeline[_date]){
                  state.countTimeline[_date]=0
                }
                state.countTimeline[_date]++
                who5_count++
                who_5.push(1)
             }else {
              who_5.push(0)
             }
            }else {
              who_5.push(0)
            }

          }
        if(year==value){
          // let cal_Culture= (Math.round((Culture_dataSumTimeline[MostRecentCulture])*100/(Culture_maxmimumTimeline[MostRecentCulture])))
          let cal_Culture = Number(((Culture_dataSumTimeline[MostRecentCulture])*100/(Culture_maxmimumTimeline[MostRecentCulture])).toFixed(1))
          // let cal_who5= Math.round((who5_dataSumTimeline[MostRecentWho5])*100/(who5_maxmimumTimeline[MostRecentWho5]))
          let cal_who5 = Number(((who5_dataSumTimeline[MostRecentWho5])*100/(who5_maxmimumTimeline[MostRecentWho5])).toFixed(1))
          let strongCompanyCultureStatus= {
              status: true,
              percentage: isNaN(cal_Culture)?0:cal_Culture,
              value: isNaN(cal_Culture)?0:cal_Culture,
              required: 80,
            }
           
            commit('setStrongCompanyCulture',strongCompanyCultureStatus)
          let who5Status= {
              status: true,
              percentage: isNaN(cal_who5)?0:cal_who5,
              value:isNaN(cal_who5)?0:cal_who5,
              required: 80,
            }
           
            commit('setHighWellBeing',who5Status)
          
          }
          for(let i=culture.length;i>0;i--){
            if(culture[i-1]==1){
              currentStreakCulture++
            }else {
              break
            }
            
          }
          for(let i=who_5.length;i>0;i--){
            if(who_5[i-1]==1){
              currentStreakwho_5++
            }else {
              break
            }
            
          }
          
          let strongCompanyCulture= {
            consistency: Math.round(Culture_count*100/diffInDays),
            currentStreak: currentStreakCulture,
            timeLine:culture,
            periods:80,
            length: culture.length,
            width:722 / culture.length
            }
       
            commit('setStrongCompanyCultureTimeline',strongCompanyCulture)
          let who5= {
            consistency: Math.round(who5_count*100/diffInDays),
            currentStreak: currentStreakwho_5,
            timeLine:who_5,
            periods:80,
            length: who_5.length,
            width:722 / who_5.length
            }
        
            commit('setHighWellBeingTimeline',who5)
            commit('setStrongCompanyCultureLoading',false)
            commit('setHighWellBeingLoading',false)
            


      })


      },


        


          
      
    

      async getRecognitionAndActiveManager({commit,rootState,dispatch,state}:any, value:any){
        commit('setRecognitionDrivenLoading',true)
        commit('setActiveManagersLoading',true)
        let countManager=0
        let year=format(new Date(),"YYYY")
        let consistencyRecognition=0
        let activeUser:any = [];
        let activeUserTimeline={}
        //let managerUser:Array<any> = [];
        let managerUserTimeline={}
        let given:any= [];
        let givenTimeline:Array<any> = [];
        let recognitionLast30={}
        let managerLast30={}
        let currentStreakactiveManagers=0
        let currentStreakRecognition=0
        let _RecognitionDrivenTimeline:Array<any> = [];
        let managerTimeline:Array<any> = [];
        let currentDate=format(new Date(),"YYYY-MM-DD")
        let last1Day=format(subDays(currentDate,1),"YYYY-MM-DD")
        let thisYear=format(new Date(`${value}-01-01`),"YYYY-MM-DD")//format(subDays(currentDate,30),"YYYY-MM-DD")
        let last30Day=format(subDays(currentDate,30),"YYYY-MM-DD")
        const diffInDays = differenceInDays(new Date(currentDate), new Date(thisYear));
        firebase.firestore().collection('summary_active_users').where("company", "==", rootState.authen.user.company).get()
      .then((querySnapshot)=> {
      querySnapshot.forEach((doc)=> {
          let data=doc.data()
         
          let date =format(data.date,"YYYY-MM-DD")
          if(data.users){
            if(date>=thisYear&&date<=currentDate)
            {
         
              activeUserTimeline[date]=data.users
              
            }
            
            if(date>=last30Day&&date<=currentDate)
              {
                activeUser.push(...data.users)
                
              }
          }

          if(data.managers){
            if(date>=thisYear&&date<=currentDate)
            {
         
              managerUserTimeline[date]=(Math.round((data.managers_qty)*100/(data.all_managers)))
              
            }
          
          }
          
        })
        if(activeUser.length > 0){
          activeUser= _.groupBy(activeUser, function (b) { return b })
        }

       // managerUser= _.groupBy(managerUser, function (b) { return b })
        if(year==value){
        let cal_activeManager=managerUserTimeline[last1Day] //(Math.round((Object.keys(managerUser).length)*100/(Object.keys(boss).length)))
        let activeManagers= {
              status: true,
              percentage: cal_activeManager?cal_activeManager:0,
              required: 50,
            }
            commit('setActiveManagers',activeManagers)
          }
        firebase.firestore().collection('summary_send_coins').where("company", "==", rootState.authen.user.company).get()
        .then((querySnapshot)=> {
        querySnapshot.forEach((doc)=> {
            let data=doc.data()
            let date =format(data.date,"YYYY-MM-DD")
            if(date>=thisYear&&date<=currentDate)
              {
             
                givenTimeline[date]=data.users

              }
                if(date>=last30Day&&date<=currentDate)
                {
                  given.push(...data.users)
                }
                
          })
            if(given.length > 0){
              given=_.groupBy(given, function (b) { return b })
            }
            if(year==value){
            let RecognitionDriven=(Math.round((Object.keys(given).length)*100/(Object.keys(activeUser).length)))
            let _Recognition_Driven={
              status: true,
              percentage: isNaN(RecognitionDriven)?0:RecognitionDriven,
              required: 70,
            }
            commit('setRecognitionDriven',_Recognition_Driven)
          }
            for(var i=0;i<=diffInDays;i++){
            let _date=format(addDays(thisYear,i),"YYYY-MM-DD")
            if(!recognitionLast30[_date]){
              recognitionLast30[_date]={given:[],activeUser:[]}
            }
            
            for(var j=0;j<30;j++){
              let beforeDate=format(subDays(_date,j),"YYYY-MM-DD")
                if(activeUserTimeline[beforeDate]&&givenTimeline[beforeDate]){
                  recognitionLast30[_date].given.push(...givenTimeline[beforeDate])
                  recognitionLast30[_date].activeUser.push(...activeUserTimeline[beforeDate])
                }
    
              if(j===29){
                recognitionLast30[_date].given=_.groupBy(recognitionLast30[_date].given, function (b) { return b })
                recognitionLast30[_date].activeUser=_.groupBy(recognitionLast30[_date].activeUser, function (b) { return b })
                var _given=(Math.round((Object.keys(recognitionLast30[_date].given).length)*100/(Object.keys(recognitionLast30[_date].activeUser).length)))
                if(_given>=70){
                 consistencyRecognition++
                _RecognitionDrivenTimeline.push(1)
                }else {
              _RecognitionDrivenTimeline.push(0)
              }

              }
            }
            var manager=managerUserTimeline[_date]
            if(manager>=50){
              countManager++
              managerTimeline.push(1)
            }else {
            managerTimeline.push(0)
            }

          } 


          for(let i=managerTimeline.length;i>0;i--){
            if(managerTimeline[i-1]==1){
              currentStreakactiveManagers++
            }else {
              break
            }
            
          }
          for(let i=_RecognitionDrivenTimeline.length;i>0;i--){
            if(_RecognitionDrivenTimeline[i-1]==1){
              currentStreakRecognition++
            }else {
              break
            }
            
          }
          let activeManagersYear= {
            consistency: Math.round(countManager*100/diffInDays),//cal_activeManagerYear,
            currentStreak: currentStreakactiveManagers,
            timeLine:managerTimeline,
            periods:50,
            length: managerTimeline.length,
            width:722 / managerTimeline.length
          }
          
          commit('setActiveManagersTimeline',activeManagersYear)
          
          let _RecognitionDrivenYear={
            consistency: Math.round(consistencyRecognition*100/diffInDays),
            currentStreak: currentStreakRecognition,
            timeLine:_RecognitionDrivenTimeline,
            periods:70,
            length: _RecognitionDrivenTimeline.length,
            width:722 / _RecognitionDrivenTimeline.length
              }
            commit('setRecognitionDrivenTimeline',_RecognitionDrivenYear)
            commit('setRecognitionDrivenLoading',false)
            commit('setActiveManagersLoading',false)
            
        })

      })

      },
     
      gethappiestWorkplaceSetData({commit,rootState,dispatch,state}:any, value:any) {
         let currentStreakHappiestWorkplace=0
         let currentDate=format(new Date(),"YYYY-MM-DD")
         let thisYear=format(new Date(`${value}-01-01`),"YYYY-MM-DD")
         const diffInDays = differenceInDays(new Date(currentDate), new Date(thisYear));
         let happiestWorkplaceStatus=0
         let happiestWorkplaceTimeLine:Array<any> = [];
         if(state.highWellBeingTimeline.timeLine.length>0&&
            state.openFeedbackTimeline.timeLine.length>0&&
            state.recognitionDrivenTimeline.timeLine.length>0&&
            state.activeManagersTimeline.timeLine.length>0&&
            state.strongCompanyCultureTimeline.timeLine.length>0
         ){
         

         for(var i=0;i<diffInDays;i++){  
           let _date=format(addDays(thisYear,i),"YYYY-MM-DD")
             let count=0
             if(state.highWellBeingTimeline.timeLine[i]>0){
             count++
             }
             if(state.openFeedbackTimeline.timeLine[i]>0){
             count++
             }
             if(state.recognitionDrivenTimeline.timeLine[i]>0){
             count++
             }
             if(state.activeManagersTimeline.timeLine[i]>0){
             count++
             }
             if(state.strongCompanyCultureTimeline.timeLine[i]>0){
             count++
             }
             if(count==5){
               happiestWorkplaceStatus++
               happiestWorkplaceTimeLine.push(1)
             }else{
               happiestWorkplaceTimeLine.push(0)
             }
         }
         for(let i=happiestWorkplaceTimeLine.length;i>0;i--){
          if(happiestWorkplaceTimeLine[i-1]==1){
            currentStreakHappiestWorkplace++
          }else {
            break
          }
          
        }
         let happiestWorkplace= {
          timeLine:happiestWorkplaceTimeLine,
          consistency:  (Math.round((happiestWorkplaceStatus)*100/(diffInDays))),
          currentStreak:currentStreakHappiestWorkplace,
          periods: 5,
          length: happiestWorkplaceTimeLine.length,
          width: 722 / happiestWorkplaceTimeLine.length,
        }
        
        commit('setHappiestWorkplaceTimeline',happiestWorkplace)
    
         }
   
       },
      



    },
    getters: {
        openFeedback : (state:any) => {
            return state.openFeedback
          },
        recognitionDriven : (state:any) => {
            return state.recognitionDriven
          },
        activeManagers : (state:any) => {
            return state.activeManagers
          },
        strongCompanyCulture : (state:any) => {
            return state.strongCompanyCulture
          },
        highWellBeing: (state:any) => {
            return state.highWellBeing
          },
          happiestWorkplace: (state:any) => {
            return state.happiestWorkplace
          },

          openFeedbackTimeline : (state:any) => {
            return state.openFeedbackTimeline
          },
        recognitionDrivenTimeline : (state:any) => {
            return state.recognitionDrivenTimeline
          },
        activeManagersTimeline : (state:any) => {
            return state.activeManagersTimeline
          },
        strongCompanyCultureTimeline : (state:any) => {
            return state.strongCompanyCultureTimeline
          },
        highWellBeingTimeline: (state:any) => {
            return state.highWellBeingTimeline
          },
 
          openFeedbackLoading: (state:any) => {
            return state.openFeedbackLoading
          },
          recognitionDrivenLoading: (state:any) => {
            return state.recognitionDrivenLoading
          },
          activeManagersLoading: (state:any) => {
            return state.activeManagersLoading
          },
          strongCompanyCultureLoading: (state:any) => {
            return state.strongCompanyCultureLoading
          },
          highWellBeingLoading: (state:any) => {
            return state.highWellBeingLoading
          },
          happiestWorkplaceTimeline: (state:any) => {
            return state.happiestWorkplaceTimeline
          },
    }
  }